<template>
  <div class="input-wrapper hd">
    <fragment v-if="['companyCheck', 'bindApplets'].includes(routeName)">
      <div class="input-box">
        <span class="name"> 入驻企业名称： </span>
        <div class="input">
          <el-input
            v-model="condition.companyName"
            clearable
            placeholder="请输入"
          />
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 统一社会信用代码： </span>
        <div class="input">
          <el-input v-model="condition.code" clearable placeholder="请输入" />
        </div>
      </div>
      <div class="input-box datepick" v-if="routeName === 'companyCheck'">
        <span class="name"> 时间： </span>
        <div class="input">
          <el-date-picker
            v-model="condition.time"
            type="daterange"
            unlink-panels
            range-separator="至"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            clearable
          />
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 企业法人： </span>
        <div class="input">
          <el-input v-model="condition.person" clearable placeholder="请输入" />
        </div>
      </div>
    </fragment>
    <fragment v-if="routeName === 'credits'">
      <div class="input-box">
        <span class="name"> 入驻企业名称： </span>
        <div class="input">
          <el-input
            v-model="condition.companyName"
            clearable
            placeholder="请输入"
          />
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 统一社会信用代码： </span>
        <div class="input">
          <el-input v-model="condition.code" clearable placeholder="请输入" />
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 企业法人： </span>
        <div class="input">
          <el-input v-model="condition.person" clearable placeholder="请输入" />
        </div>
      </div>
      <div class="input-box datepicks">
        <span class="name">时间：</span>
        <div class="input">
          <el-date-picker
            v-model="condition.time"
            type="date"
            unlink-panels
            placeholder="请选择"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            clearable
            :picker-options="pickerOptions"
          />
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 初始信用额度： </span>
        <div class="input">
          <el-input
            v-model="condition.startPrice"
            clearable
            placeholder="请输入"
          />
        </div>
        至
        <div class="input">
          <el-input
            v-model="condition.endPrice"
            clearable
            placeholder="请输入"
          />
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 额度状态： </span>
        <div class="input">
          <el-select v-model="condition.status" clearable placeholder="请选择">
          </el-select>
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 联系人电话： </span>
        <div class="input">
          <el-input v-model="condition.phone" clearable placeholder="请输入" />
        </div>
      </div>
    </fragment>
    <fragment v-if="routeName === 'goodsCheck'">
      <div class="input-box">
        <span class="name"> 企业名称： </span>
        <div class="input">
          <el-input
            v-model="condition.companyName"
            clearable
            placeholder="请输入"
          />
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 商品名称： </span>
        <div class="input">
          <el-input
            v-model="condition.goodsName"
            clearable
            placeholder="请输入"
          />
        </div>
      </div>
    </fragment>
    <fragment v-if="routeName === 'goodsAuthorized'">
      <div class="input-box">
        <span class="name"> 统一社会信用代码： </span>
        <div class="input">
          <el-input v-model="condition.code" clearable placeholder="请输入" />
        </div>
      </div>
      <div class="input-box">
        <span class="name"> 入驻企业名称： </span>
        <div class="input">
          <el-input
            v-model="condition.companyName"
            clearable
            placeholder="请输入"
          />
        </div>
      </div>
    </fragment>
    <slot />
    <el-button
      class="iconfont icon-sousuo"
      size="60"
      round
      @click="searchData"
    />
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'

export default {
  name: 'SearchComponent',
  mixins: [pickerOptions],
  props: {
    condition: {
      type: Object,
      default: () => {
        return {}
      },
    },
    routeName: {
      type: String,
    },
  },
  methods: {
    /**
     * 搜索
     */
    searchData() {
      const condition = this._returnSearchCondition()
      this.$emit('updateData', (vm) => {
        switch (this.routeName) {
          case 'companyCheck':
            vm._getMerchantList({
              ...condition,
              merchant_state: vm.activeName,
            })
            break
          case 'bindApplets':
            vm._getBindList(condition)
            break
          case 'goodsCheck':
            vm._getMerchantGoodsList({
              ...condition,
              audit_status: vm.activeName,
            })
            break
          case 'goodsAuthorized':
            vm._getGoodsAuthorizedList(condition)
            break
          case 'authorized':
            vm._getGoodsAuthorized({
              ...condition,
              search_model: vm.search_model[+vm.activeName - 1],
              merchant_id: this.$route.query.id,
            })
            break
        }
      })
    },
    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchCondition() {
      const {
        companyName,
        code,
        time,
        person,
        goodsName,
        sku,
        goodsType,
      } = this.condition
      const data = {
        enterprise_name: companyName,
        legal_person: person,
        start_time: time && time[0],
        end_time: time && time[1],
        credit_code: code,
        goods_name: goodsName,
        goods_sku: sku,
        goods_type: goodsType,
      }
      this.utils._checkSearchCondition(data)
      return data
    },
  },
}
</script>
